import React, { useEffect, useState } from 'react';
import { CircularProgress, FormControlLabel, Box } from '@mui/material';
import { BaseSwitch } from '../style/switch';
import { TypographyLeftMenu } from '../style/typography';

export default function Switch6h15h(props) {

  const [loading, setLoading] = useState(false);

  // ローディング終了
  useEffect(() => {
    if (Object.values(props.isReady).every(v => v === true)
    ) {
      setLoading(false)
    }
  }, [props.isReady]);

  const handleSwitchChange = (event) => {
    // リセットボタンのローディング開始
    setLoading(true)

    // 各チャートのローディング開始
    props.setReady(prev => {
      const updated = Object.fromEntries(
        Object.keys(prev).map(key => [key, false])
      );
      return updated;
    });

    // ローディング開始後にモード切り替え処理を開始
    requestAnimationFrame(() => {
      setTimeout(() => {
        props.setH6Switch(!props.h6Switch);
      }, 0);
    });
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="left">
      <FormControlLabel
        control={
          <>
            <BaseSwitch
              checked={props.h6Switch}
              onChange={handleSwitchChange}
            />
          </>
        }
        label={
          loading ?
            <CircularProgress
              size={10}
              color="inherit"
              disableShrink
              component="span"
              sx={{
                color: 'white',
                '& circle': {
                  stroke: 'white',
                },
              }}
            />
            :
            <TypographyLeftMenu sx={{
              fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)' },
            }}>
              6時間モード
            </TypographyLeftMenu>
        }
      />
    </Box>
  );
}
